import BaseService from "../index";

export default {
    get() {
        return BaseService.get(`/cms/category-page`);
    },

    update(params) {
        return BaseService.put(`/cms/category-page`, params);
    },
};
